// Internal modules
import {
  CRS_FIRST_NAME_ID,
  SET_LEGAL_FIRST_NAME,
  SET_LEGAL_LAST_NAME,
} from './../constants';
import type { CRSEventDispatcher, CRSLegalNamesType } from '../types';

export const crsLegalNamesChangeHandler = (
  event: React.ChangeEvent<HTMLInputElement>,
  dispatch: CRSEventDispatcher,
  crsLegalNames: CRSLegalNamesType,
): void => {
  const { id, value } = event.target;

  dispatch({
    type: id === CRS_FIRST_NAME_ID ? SET_LEGAL_FIRST_NAME : SET_LEGAL_LAST_NAME,
    value: {
      ...crsLegalNames[id as keyof CRSLegalNamesType],
      displayError: false,
      error: '',
      value,
    },
  });
};
